module.exports = __webpack_public_path__ + "img/ico-prev.48202c2c.svg";